import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../ui/Button";
import FormInput from "../ui/FormInput";
import EditableTable from "../ui/EditableTable";
import Modal from "../ui/Modal";
import State, { STATE, CurrentEntityState, CurrentStudyState } from "@state";
import { useSession } from "@/hooks/useSession";
import { v4 as uuidv4 } from "uuid";
import NavigationService from "@/network/services/navigation.service";
import InvitationController from "@/network/controllers/invitation.controller";
import StatusBadge from "../ui/StatusBadge";
import StudyController from "@/network/controllers/study.controller";

export default function RoleManagement({ onNext, onPrev }) {
  const [initialLocalData, setInitialLocalData] = useState({});
  const navigate = NavigationService.navigateTo;
  const { user } = useSession();
  const studyId = STATE[CurrentStudyState.STUDY]?.tmpId;

  const [showUnaddedWarning, setShowUnaddedWarning] = useState(false);
  const milestones = STATE[CurrentStudyState.MILESTONES];
  const [studyManagers, setStudyManagers] = useState(() => {
    /** ------------------ cmt 387381 ------------------
     * TODO: 
    if (studyData.studyManagers && studyData.studyManagers.length > 0) {
      console.log("studyData.studyManagers:", studyData.studyManagers)
      return studyData.studyManagers
    }
    *-------------------------------------------------*/
   const currentEntityName = STATE[CurrentEntityState.CURRENT_ENTITY_DATA]?.entity_data?.contact?.entityName;

    const defaultManager = {
      tmpid: uuidv4(),
      userId: user.userId,
      name: currentEntityName, 
      contactName: user.firstname + " " + user.lastname,
      email: user.email,
    };
    console.log("Manager de default:", [defaultManager]);
    State.setValue(CurrentStudyState.CRO_MANAGERS, [defaultManager]);
    return [defaultManager];
  });
  const [isSendingManagerInvitation, setIsSendingManagerInvitation] =
    useState(false);
  const [managerInvitationError, setManagerInvitationError] = useState(null);
  const [isSendingInvestigatorInvitation, setIsSendingInvestigatorInvitation] =
    useState(false);
  const [investigatorInvitationError, setInvestigatorInvitationError] =
    useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [pendingManagers, setPendingManagers] = useState([]);
  const [pendingInvestigators, setPendingInvestigators] = useState([]);

  const [investigators, setInvestigators] = useState([
    /** ------------------ cmt 783886 ------------------
      {
        tmpid: uuidv4(),
        userId: user.id,
        name: "Dr. Sarah Johnson",
        email: "sarah.johnson@medcenter.com",
        phone: "+1 (555) 123-4567",
        site: "Medical Center Research Facility",
      },
     *-------------------------------------------------*/
  ]);

  const [newManager, setNewManager] = useState({
    tmpid: uuidv4(),
    userId: null,
    name: "",
    contactName: "",
    email: "",
  });

  const [newInvestigator, setNewInvestigator] = useState({
    tmpid: uuidv4(),
    userId: null,
    name: "",
    email: "",
    phone: "",
    site_id: "",
  });

  async function checkStudyExists(studyId) {
    const result = await StudyController.studyExist(studyId);
    if (!result.success) {
      throw new Error(result.message || "Study existence check failed");
    }
    return result.exists;
  }

  // Modal state
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    const initialData = {
      name: STATE[CurrentStudyState.STUDY].name,
      estimatedDuration: STATE[CurrentStudyState.STUDY].estimatedDuration,
      thresholdOfParticipants:
        STATE[CurrentStudyState.STUDY].thresholdOfParticipants,
      masterIcfs: STATE[CurrentStudyState.MASTER_ICFS],
      milestones: STATE[CurrentStudyState.MILESTONES],
      sites: STATE[CurrentStudyState.SITES],
      studyManagers: STATE[CurrentStudyState.CRO_MANAGERS],
      investigators: STATE[CurrentStudyState.INVESTIGATORS],
    };
    setInitialLocalData(initialData);

    console.log(
      "=== Contenuto di STATE[CurrentStudyState.SITES] === RoleManagement.jsx ==="
    );

    console.log("=== initialData === RoleManagement.jsx === key: 555523 ===");
    console.dir(initialData, { depth: null, colors: true });
    console.log("=================================");
  }, []);

  // Study Managers DataTable columns
  const studyManagerColumns = [
    { key: "name", header: "Study manager name", width: "33%" },
    { key: "contactName", header: "Contact name", width: "33%" },
    { key: "email", header: "Email address", width: "34%" },
  ];

  // Investigators DataTable columns
  const investigatorColumns = [
    { key: "name", header: "Investigator name", width: "25%" },
    { key: "email", header: "Email address", width: "25%" },
    { key: "phone", header: "Phone number", width: "25%" },
    { key: "site_id", header: "Assigned site", width: "25%" },
  ];

  // Handle input change for new manager
  const handleManagerInputChange = (e) => {
    const { name, value } = e.target;
    setNewManager((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle input change for new investigator
  const handleInvestigatorInputChange = (e) => {
    const { name, value } = e.target;
    console.log(
      "DEBUG: handleInvestigatorInputChange - name: ${name}, value: ${value}"
    );
    setNewInvestigator((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleAddManager = () => {
    if (!newManager.name || !newManager.contactName || !newManager.email) {
      alert("Please fill in all required fields");
      return;
    }
    const entityId = STATE[CurrentEntityState.CURRENT_ENTITY_DATA]?.id;
    const entry = {
      id: uuidv4(),
      firstname: newManager.name.split(" ")[0],
      lastname: newManager.name.split(" ")[1] || "",
      contact_name: newManager.contactName,
      email: newManager.email,
      invitation_type: "join_cro",
      entity_id: entityId || null,
    };
    setPendingManagers((prev) => [...prev, entry]);

    const tableEntry = {
      tmpid: uuidv4(),
      id: entry.id,
      userId: null,
      name: newManager.name,
      contactName: newManager.contactName,
      email: newManager.email,
      invitation_status: "pending",
    };
    setStudyManagers((prev) => [...prev, tableEntry]);
    setNewManager({
      tmpid: uuidv4(),
      userId: null,
      name: "",
      contactName: "",
      email: "",
    });
  };

  console.log("PENDING MANAGERS:", pendingManagers);

  // Add new investigator
  const handleAddInvestigator = () => {
    if (
      !newInvestigator.name ||
      !newInvestigator.email ||
      !newInvestigator.phone ||
      !newInvestigator.site_id
    ) {
      alert("Please fill in all required fields");
      return;
    }
    const entityId = STATE[CurrentEntityState.CURRENT_ENTITY_DATA]?.id;

    const entry = {
      id: uuidv4(),
      firstname: newInvestigator.name.split(" ")[0],
      lastname: newInvestigator.name.split(" ")[1] || "",
      email: newInvestigator.email,
      phone: newInvestigator.phone,
      site_id: newInvestigator.site_id || null,
      invitation_type: "investigator",
      phone_number: newInvestigator.phone || null,
      entity_id: entityId || null,
    };

    setPendingInvestigators((prev) => [...prev, entry]);

    const siteObj = (STATE[CurrentStudyState.SITES] || []).find(
      (s) =>
        s.siteId === newInvestigator.site_id ||
        s.tmpid === newInvestigator.site_id
    );
    const tableEntry = {
      tmpid: uuidv4(),
      id: entry.id,
      userId: null,
      name: newInvestigator.name,
      email: newInvestigator.email,
      phone: newInvestigator.phone,
      site_id: newInvestigator.site_id,
      siteName: siteObj?.siteName || "",
      invitation_status: "pending",
    };
    setInvestigators((prev) => [...prev, tableEntry]);

    setNewInvestigator({
      tmpid: uuidv4(),
      userId: null,
      name: "",
      email: "",
      phone: "",
      site_id: "",
    });
  };
  console.log("PENDING INVESTIGATORS:", pendingInvestigators);

  // Handle edit study manager
  const handleEditManager = (updatedManager) => {
    const updatedManagers = studyManagers.map((manager) =>
      manager.tmpid === updatedManager.tmpid ? updatedManager : manager
    );
    setStudyManagers(updatedManagers);
    const study = STATE[CurrentStudyState.STUDY];
    study.studyManagers = updatedManagers;
    State.setValue(CurrentStudyState.STUDY, study);
    State.setValue(CurrentStudyState.CRO_MANAGERS, updatedManagers);
    //onUpdateStudyData({ studyManagers: updatedManagers })
  };

  // Handle delete study manager
  const handleDeleteManager = (manager) => {
    const updatedManagers = studyManagers.filter(
      (m) => m.tmpid !== manager.tmpid
    );
    setStudyManagers(updatedManagers);
    onUpdateStudyData({ studyManagers: updatedManagers });
  };

  // Handle reorder study managers
  const handleReorderManagers = (oldIndex, newIndex) => {
    const updatedManagers = [...studyManagers];
    const [movedItem] = updatedManagers.splice(oldIndex, 1);
    updatedManagers.splice(newIndex, 0, movedItem);
    setStudyManagers(updatedManagers);
    onUpdateStudyData({ studyManagers: updatedManagers });
  };

  // Handle edit investigator
  const handleEditInvestigator = (updatedInvestigator) => {
    const updatedInvestigators = investigators.map((investigator) =>
      investigator.tmpid === updatedInvestigator.tmpid
        ? updatedInvestigator
        : investigator
    );
    setInvestigators(updatedInvestigators);
    
    const study = STATE[CurrentStudyState.STUDY];
    study.investigators = updatedInvestigators;
    State.setValue(CurrentStudyState.STUDY, study);
    State.setValue(CurrentStudyState.INVESTIGATORS, updatedInvestigators);
  };

  // Handle delete investigator
  const handleDeleteInvestigator = (investigator) => {
    const updatedInvestigators = investigators.filter(
      (i) => i.tmpid !== investigator.tmpid
    );
    setInvestigators(updatedInvestigators);
    onUpdateStudyData({ investigators: updatedInvestigators });
  };

  // Handle reorder investigators
  const handleReorderInvestigators = (oldIndex, newIndex) => {
    const updatedInvestigators = [...investigators];
    const [movedItem] = updatedInvestigators.splice(oldIndex, 1);
    updatedInvestigators.splice(newIndex, 0, movedItem);
    setInvestigators(updatedInvestigators);
    onUpdateStudyData({ investigators: updatedInvestigators });
  };

  const hasUnaddedManager =
    newManager.name?.trim() ||
    newManager.contactName?.trim() ||
    newManager.email?.trim();

  const hasUnaddedInvestigator =
    newInvestigator.name?.trim() ||
    newInvestigator.email?.trim() ||
    newInvestigator.phone?.trim() ||
    newInvestigator.site_id?.toString()?.trim();

    const proceedContinue = async () => {
      const study = STATE[CurrentStudyState.STUDY];
      study.studyManagers = studyManagers;
      study.investigators = investigators;
      State.setValue(CurrentStudyState.STUDY, study);
      State.setValue(CurrentStudyState.CRO_MANAGERS, studyManagers);
      State.setValue(CurrentStudyState.INVESTIGATORS, investigators);
    
      setIsProcessing(true);
    
      const studyId = STATE[CurrentStudyState.STUDY]?.tmpId;
      let intervalId;
    
      try {

        await new Promise((resolve, reject) => {
          intervalId = setInterval(async () => {
            try {
              if (await checkStudyExists(studyId)) {
                clearInterval(intervalId);
                resolve();
              }
            } catch (e) {
              clearInterval(intervalId);
              reject(e);
            }
          }, 2000);
        });
    
    
        const masterIcf = STATE[CurrentStudyState.MASTER_ICFS]?.[0];
        const masterIcfId = masterIcf?.id || masterIcf?.tmpId || null;
    
        console.log("🔎 Resolved masterIcfId:", masterIcfId);
    

        const milestones = (STATE[CurrentStudyState.MILESTONES] || []).map((m) => ({
          ...m,
          masterIcfId,
        }));
    
        console.log("🚚 Milestones payload to backend:", milestones);
    
        if (milestones.length > 0) {
          const milestoneResp = await StudyController.addMilestonesToStudy(studyId, milestones);
          if (milestoneResp?.success === false) {
            throw new Error(milestoneResp.message || "Failed to send milestones");
          }
        }
    

        const hasPending = pendingManagers.length > 0 || pendingInvestigators.length > 0;
    
        if (pendingManagers.length > 0) {
          await Promise.all(
            pendingManagers.map((m) =>
              InvitationController.sendProtectedInvitation({ ...m, study_id: studyId })
            )
          );
        }
    
        if (pendingInvestigators.length > 0) {
          await Promise.all(
            pendingInvestigators.map((i) =>
              InvitationController.sendProtectedInvitation({ ...i, study_id: studyId })
            )
          );
        }
    
        if (hasPending) {
          setPendingManagers([]);
          setPendingInvestigators([]);
        }
    
        setShowSuccessModal(true);
      } catch (error) {
        console.log("=== error === RoleManagement.jsx === key: 194258 ===");
        console.dir(error, { depth: null, colors: true });
        alert("An error occurred while finalizing and sending invitations.");
      } finally {
        if (intervalId) clearInterval(intervalId);
        setIsProcessing(false);
      }
    };
    

  const handleContinue = async () => {
    if (hasUnaddedManager || hasUnaddedInvestigator) {
      setShowUnaddedWarning(true);
      return;
    }
    await proceedContinue();
  };

  // Handle go to dashboard
  const handleGoToDashboard = () => {
    navigate("/dashboard");
  };

  // Custom cell renderer for EditableTable
  const renderManagerCell = (key, item, value, onChange, isEditMode) => {
    if (isEditMode) {
      return (
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange && onChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
        />
      );
    }
    return value;
  };

  // Custom cell renderer for investigators
  const renderInvestigatorCell = (key, item, value, onChange, isEditMode) => {
    const sites = STATE[CurrentStudyState.SITES];
    if (key === "site_id" && isEditMode) {
      return (
        <select
          value={value || ""}
          onChange={(e) => {
            const selectedId = e.target.value;
            onChange(selectedId);
          }}
          className="w-full px-3 py-2 border bg-white border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
        >
          <option value="">Select</option>
          {sites &&
            sites.map((site) => (
              <option key={site.siteId || site.tmpid} value={site.siteId}>
                {site.siteName}
              </option>
            ))}
        </select>
      );
    }
    if (key === "site_id" && !isEditMode) {
      const siteObj = sites.find(
        (s) => s.siteId === value || s.tmpid === value
      );
      return <span>{siteObj?.siteName || "N/A"}</span>;
    }
    if (isEditMode) {
      return (
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange && onChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
        />
      );
    }
    return value;
  };

  return (
    <div className="">
      <h2 className="mb-2 text-xl font-semibold">Role management</h2>
  
      {/* Study Management Section */}
      <div className="mb-8">
        <h3 className="mb-4 text-lg font-medium">Study management</h3>
  
        {/* Table wrapper: avoid horizontal clipping on small screens */}
        <div className="mb-3 -mx-2 sm:mx-0">
        <div className="overflow-x-auto px-3 sm:px-0" style={{ scrollbarGutter: "stable both-edges" }}>
        <div className="min-w-[1120px] sm:min-w-[1120px] md:min-w-[1180px]">
              <EditableTable
                items={studyManagers}
                columns={studyManagerColumns}
                onEdit={handleEditManager}
                onDelete={handleDeleteManager}
                onReorder={handleReorderManagers}
                emptyMessage="No study managers have been added yet."
                saveModalTitle="Save manager changes"
                saveModalMessage="You are about to save the modifications made to the study managers. "
                saveModalP="Once saved, these modifications will be applied to the study and may affect the workflow."
                cancelModalTitle="Discard manager changes"
                cancelModalMessage="You are about to discard all modifications made to the study managers."
                deleteModalTitle="Delete study manager"
                deleteModalMessage="You are about to permanently delete this study manager."
                renderCell={renderManagerCell}
                firstRowEditable={false}
              />
            </div>
          </div>
        </div>
  
        {/* Add Study Manager Form */}
        <div className="mb-6">
          <h4 className="mb-3 text-lg font-medium">Add study manager</h4>
          {/* Stack on mobile, 3 cols on ≥md; keep button aligned without overflow */}
          <div className="grid grid-cols-1 items-end gap-4 md:grid-cols-3">
            <div className="min-w-0">
              <FormInput
                label="Study manager name"
                name="name"
                value={newManager.name}
                onChange={handleManagerInputChange}
                placeholder="Sponsor name, CRO name, ..."
              />
            </div>
            <div className="min-w-0">
              <FormInput
                label="Contact name"
                name="contactName"
                value={newManager.contactName}
                onChange={handleManagerInputChange}
                placeholder="First and last name"
              />
            </div>
            <div className="min-w-0">
              <FormInput
                label="Email address"
                name="email"
                type="email"
                value={newManager.email}
                onChange={handleManagerInputChange}
                placeholder="name@mail.com"
              />
            </div>
            <div className="md:col-span-3">
              <Button
                onClick={handleAddManager}
                variant="addbutton"
                className="w-full px-4 py-2 sm:w-auto"
                disabled={isSendingManagerInvitation}
              >
                Add Manager
              </Button>
            </div>
          </div>
        </div>
      </div>
  
      {/* Investigators Section */}
      <div className="mb-8">
        <h3 className="mb-4 text-lg font-medium">Investigator(s)</h3>
  
        {/* Table wrapper */}
        <div className="mb-6 -mx-2 sm:mx-0">
        <div className="overflow-x-auto px-3 sm:px-0" style={{ scrollbarGutter: "stable both-edges" }}>
          <div className="min-w-[1120px] sm:min-w-[1120px] md:min-w-[1180px]">
              <EditableTable
                items={investigators}
                columns={investigatorColumns}
                onEdit={handleEditInvestigator}
                onDelete={handleDeleteInvestigator}
                onReorder={handleReorderInvestigators}
                emptyMessage="No investigators have been invited yet. They will appear in the table once added."
                saveModalTitle="Save investigator changes"
                saveModalMessage="You are about to save the modifications made to the investigators."
                cancelModalTitle="Discard investigator changes"
                cancelModalMessage="You are about to discard all modifications made to the investigators."
                deleteModalTitle="Delete investigator"
                deleteModalMessage="You are about to permanently delete this investigator."
                renderCell={renderInvestigatorCell}
                firstRowEditable={true}
              />
            </div>
          </div>
        </div>
  
        {/* Add Investigator Form */}
        <div className="mb-6">
          <h4 className="mb-3 text-md font-medium">Add investigator</h4>
          {/* 4 cols on ≥md; button goes full width on mobile */}
          <div className="grid grid-cols-1 items-end gap-4 md:grid-cols-4">
            <div className="min-w-0">
              <FormInput
                label="Investigator name"
                name="name"
                value={newInvestigator.name}
                onChange={handleInvestigatorInputChange}
                placeholder="First and last name"
              />
            </div>
            <div className="min-w-0">
              <FormInput
                label="Email address"
                name="email"
                type="email"
                value={newInvestigator.email}
                onChange={handleInvestigatorInputChange}
                placeholder="name@mail.com"
              />
            </div>
            <div className="min-w-0">
              <FormInput
                label="Phone number"
                name="phone"
                type="tel"
                value={newInvestigator.phone}
                onChange={handleInvestigatorInputChange}
                placeholder="+12481237654"
              />
            </div>
            <div className="min-w-0">
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Assigned site
              </label>
              <select
                name="site_id"
                value={newInvestigator.site_id}
                onChange={handleInvestigatorInputChange}
                className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
              >
                <option value="">Select</option>
                {STATE[CurrentStudyState.SITES] &&
                  STATE[CurrentStudyState.SITES].map((site) => (
                    <option key={site.siteId || site.tmpid} value={site.siteId}>
                      {site.siteName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="md:col-span-4">
              <Button
                onClick={handleAddInvestigator}
                variant="addbutton"
                className="w-full px-4 py-2 sm:w-auto"
                disabled={isSendingManagerInvitation}
              >
                Add Investigator
              </Button>
            </div>
          </div>
        </div>
      </div>
  
      {/* Navigation Buttons */}
      <div className="mt-8">
        <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:justify-end">
          {/* <Button onClick={onPrev} variant="createstudy" className="px-6 py-2">Back</Button> */}
          <Button onClick={handleContinue} variant="createstudy" className="w-full px-6 py-2 sm:w-auto">
            Continue
          </Button>
        </div>
      </div>
  
      {/* Modals (unchanged) */}
      <Modal
        isOpen={showUnaddedWarning}
        onClose={() => setShowUnaddedWarning(false)}
        title="Unsaved entries detected"
        primaryAction={async () => { setShowUnaddedWarning(false); await proceedContinue(); }}
        primaryActionLabel="Continue anyway"
        secondaryAction={() => setShowUnaddedWarning(false)}
        secondaryActionLabel="Go back"
        size="xl"
      >
        <div className="space-y-2 text-lg">
          <p>
            You didn't click <b>Add</b>. If you continue, the invitation will
            not be sent.
          </p>
          {(hasUnaddedManager || hasUnaddedInvestigator) && (
            <ul className="list-inside list-disc text-md text-gray-600">
              {hasUnaddedManager && <li>Study manager form has unsaved data.</li>}
              {hasUnaddedInvestigator && <li>Investigator form has unsaved data.</li>}
            </ul>
          )}
        </div>
      </Modal>
  
      <Modal isOpen={isProcessing} onClose={() => {}} title="Please wait…" hideCloseButton size="md">
        <div className="flex flex-col items-center gap-4 p-6">
          <svg className="h-8 w-8 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <p className="text-center">Please wait while we process your request…</p>
        </div>
      </Modal>
  
      <Modal
        isOpen={showSuccessModal}
        onClose={() => {}}
        title="Study successfully created"
        primaryAction={handleGoToDashboard}
        primaryActionLabel="Go to dashboard"
        showCloseButton={false}
        size="md"
      >
        <div className="text-center">
          <p className="mb-4">
            The study has been successfully created, and all required
            information has been recorded.
          </p>
          <p className="mb-4">
            You can modify the study details at any time through the study
            settings.
          </p>
        </div>
      </Modal>
    </div>
  );
          }